import api from '../config/axiosConfig';

const deliveryService = {
  overview: (workOrderId) => api.get(`/deliveries/work-order/${workOrderId}`).then((r) => r.data),
  release: (detailId, payload) => api.post(`/deliveries/detail/${detailId}/release`, payload).then((r) => r.data),
  resendNotice: (packageId) => api.post(`/deliveries/${packageId}/resend-notice`).then((r) => r.data),
  physicalAck: (packageId, { receivedBy, deliveredOn, evidence }) => {
    const form = new FormData();
    form.append('receivedBy', receivedBy);
    if (deliveredOn) form.append('deliveredOn', deliveredOn);
    if (evidence) form.append('evidence', evidence);
    return api.post(`/deliveries/${packageId}/physical-ack`, form, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  mine: () => api.get('/deliveries/mine').then((r) => r.data),
  acknowledge: (packageId, receivedBy) => api.post(`/deliveries/${packageId}/acknowledge`, { receivedBy, confirmed: true }).then((r) => r.data),
  download: async (packageId, item) => {
    const response = await api.get(`/deliveries/${packageId}/items/${item.id}/download`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = item.fileName || `${item.label}.docx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};

export default deliveryService;
